export default "__VITE_ASSET__B$fvqrHF__"